import { observable, set } from 'mobx';
import { IValue, ValueEntity, IKeyValue, KeyValueEntity } from './BasicEntities';

export interface IProductSkin {
    type: IValue[];
    concern: IKeyValue[];
}

class Type extends ValueEntity {}
class Concern extends KeyValueEntity {}

export class ProductSkin {
    @observable public type: Type[] = [];
    public concern: KeyValueEntity[] = [];

    public static fromPlainObject(payload: ProductSkin): ProductSkin {
        const skin = new ProductSkin();
        set(skin, payload);

        return skin;
    }

    public static fromJson(skin: IProductSkin): ProductSkin {
        const newSkin = new ProductSkin();
        if (!skin) {
            return newSkin;
        }

        newSkin.type = skin.type
            ? skin.type.map(data => {
                  return Type.fromJson({
                      key: data.key ? data.key.trim() : '',
                      value: data.value && data.value.trim()
                  });
              })
            : [];

        newSkin.concern = skin.concern
            ? skin.concern.map(data => {
                  return Concern.fromJson({
                      key: data.key ? data.key.trim() : '',
                      value: data.value && data.value.trim()
                  });
              })
            : [];

        return newSkin;
    }

    public toJSON(): IProductSkin {
        return {
            type: this.type,
            concern: this.concern
        };
    }
}
